var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31197",
    "data-name": "Group 31197",
    transform: "translate(9751 20032.664)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-9751 -20032.664)",
    fill: "#14b7dd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "unlink",
    transform: "translate(-9744.466 -20026.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130932",
    "data-name": "Path 130932",
    d: "M5.094,18.348A3.361,3.361,0,0,1,1.7,14.955a3.184,3.184,0,0,1,1.018-2.375L5.094,10.2a.672.672,0,1,1,.95.95L3.668,13.529A2.016,2.016,0,0,0,6.519,16.38L8.894,14a.672.672,0,0,1,.95.95L7.469,17.33a3.184,3.184,0,0,1-2.375,1.018Z",
    transform: "translate(-0.225 -2.892)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130933",
    "data-name": "Path 130933",
    d: "M14.479,10.176A.641.641,0,0,1,13.8,9.5a.616.616,0,0,1,.2-.475L16.38,6.647A2.016,2.016,0,0,0,13.529,3.8L11.154,6.172a.672.672,0,0,1-.95-.95l2.375-2.375a3.42,3.42,0,0,1,4.819.068,3.318,3.318,0,0,1,0,4.683L15.022,9.973a.9.9,0,0,1-.543.2Z",
    transform: "translate(-2.892 -0.285)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130934",
    "data-name": "Path 130934",
    d: "M7.679,3.715A.641.641,0,0,1,7,3.036V1.679A.641.641,0,0,1,7.679,1a.641.641,0,0,1,.679.679V3.036A.641.641,0,0,1,7.679,3.715Z",
    transform: "translate(-1.928)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130935",
    "data-name": "Path 130935",
    d: "M3.036,8.357H1.679A.641.641,0,0,1,1,7.679.641.641,0,0,1,1.679,7H3.036a.641.641,0,0,1,.679.679A.641.641,0,0,1,3.036,8.357Z",
    transform: "translate(0 -1.928)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130936",
    "data-name": "Path 130936",
    d: "M4.036,4.715a.616.616,0,0,1-.475-.2L2.2,3.154a.672.672,0,0,1,.95-.95L4.511,3.561a.656.656,0,0,1,0,.95A.616.616,0,0,1,4.036,4.715Z",
    transform: "translate(-0.321 -0.321)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130937",
    "data-name": "Path 130937",
    d: "M21.036,16.357H19.679a.679.679,0,0,1,0-1.357h1.357a.679.679,0,1,1,0,1.357Z",
    transform: "translate(-5.783 -4.498)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130938",
    "data-name": "Path 130938",
    d: "M15.679,21.715A.641.641,0,0,1,15,21.036V19.679a.679.679,0,0,1,1.357,0v1.357A.641.641,0,0,1,15.679,21.715Z",
    transform: "translate(-4.498 -5.783)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130939",
    "data-name": "Path 130939",
    d: "M20.036,20.715a.616.616,0,0,1-.475-.2L18.2,19.154a.672.672,0,0,1,.95-.95l1.357,1.357a.656.656,0,0,1,0,.95A.616.616,0,0,1,20.036,20.715Z",
    transform: "translate(-5.462 -5.462)",
    fill: "#76747f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/Unlink.4d1e9ff8426d45436864aee7e6c70d70.svg";
export { ForwardRef as ReactComponent };